var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTransferIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 23C22.1046 23 23 22.1046 23 21L23 3C23 1.89543 22.1046 1 21 1L3 0.999998C1.89543 0.999998 1 1.89543 1 3L1 21C1 22.1046 1.89543 23 3 23L21 23ZM15 18.1176C15 17.8612 14.9015 17.6146 14.7249 17.4288L9.48755 11.9173L14.6786 6.55638C14.8559 6.3733 14.9566 6.12945 14.9601 5.87463L14.9662 5.43194C14.9786 4.5386 13.9026 4.0786 13.2654 4.70486L6.67851 11.1787C6.54225 11.3126 6.45251 11.4759 6.40939 11.6485C6.31685 11.9841 6.40246 12.3586 6.66623 12.6223L13.2929 19.249C13.9229 19.879 15 19.4328 15 18.5419L15 18.1176Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransferIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transfer-icon.88eed366.svg";
export { ForwardRef as ReactComponent };